export enum TableCreationMethod {
  Files = 'files',
  Blank = 'blank',
  Assistant = 'assistant',
}

export enum TableEntrySource {
  TableList = 'tableList',
  Chat = 'chat',
  MatterOverview = 'matterOverview',
}

export enum TableEditAction {
  AddRow = 'add_row',
  DeleteRow = 'delete_row',
  DeleteRows = 'delete_rows',
  AddColumn = 'add_column',
  AddAnalysisColumn = 'add_analysis_column',
  EditColumn = 'edit_column',
  DeleteColumn = 'delete_column',
  EditCell = 'edit_cell',
}

export enum TableEditSource {
  Manual = 'manual',
  Chat = 'chat',
}

export enum TableFilterMatch {
  All = 'all',
  Any = 'any',
}

export enum TableDownloadScope {
  Filtered = 'filtered',
  All = 'all',
}

export enum TableDocumentSource {
  Upload = 'upload',
  ExistingMatterFiles = 'existingMatterFiles',
}

export enum TableCopyMethod {
  Action = 'action',
  Shortcut = 'shortcut',
  Clipboard = 'clipboard',
}
